<template>
    <div 
        id="product_setting_items"
        class="product-setting-items"
    >
        <div class="product-setting-items__title">
            <span class="text">
                {{ $t('__product_setting.title') }}
            </span>
            <v-icon class="close_24px" 
                color="white" 
                @click="close_product_setting_dialog"
            >
                icon-close
            </v-icon>
        </div>

        <draggable
            v-model="mutable_product_setting_items"
            @change="change_order(order_name_list, $event.moved)"
            class="draggable-item"
            handle=".handle"
        >
            <div v-for="(item, key) in mutable_product_setting_items"
                :key="key"
                :title="$t('__product_setting.draggable_tooltip_text')"
                @click.stop
            >  
                <div 
                    class="product-setting-item" 
                    :class="{
                        'empty-wrapper': item.is_on_map === false
                    }"
                >
                    <template v-if="item.is_on_map && !judge_empty_data(item.tag_config)">
                        <div class="product-setting-content__title d-flex align-center justify-space-between">
                            <div class="d-flex align-center">
                                <span 
                                    class="product-setting-content__visibility-btn"
                                    @click="toggle_visibility(item.name, item.visibility_by_user)"
                                >
                                    <v-icon 
                                        class="svg-icon" 
                                        :color="item.visibility_by_user ? 'white' : 'grey'"
                                    >
                                        icon-visibility
                                    </v-icon>
                                </span>
                                <span>{{ item.text }}</span>
                            </div>
                            
                            <v-icon class="handle svg-icon"
                                color="#b3b7c4" 
                            >
                                icon-move
                            </v-icon>
                        </div>
                        <div> 
                            <div v-if="item.name === radar_id"
                                class="product-setting-content__item"
                            >
                                <RadarControl />
                            </div>

                            <div v-if="['station', 'auto', 'gauge'].includes(item.sub_type)"
                                class="gis-slider product-setting-content__item" 
                            >
                                <span class="gis-slider__title">
                                    {{ $t('__product_setting.map_zoom') }}
                                </span>
                                <v-slider
                                    v-model="zoom_level"
                                    step="1"
                                    ticks
                                    :max="all_map_config.map.options.maxZoom"
                                    :min="all_map_config.map.options.minZoom"
                                    :tick-labels="get_gis_slider_labels(all_map_config, item.sub_type)"
                                >
                                    <template #prepend>
                                        <span class="gis-slider__hint-text">{{ $t('__product_setting.least') }}</span>
                                    </template>
                                    <template #append>
                                        <span class="gis-slider__hint-text">{{ $t('__product_setting.largest') }}</span>
                                    </template>
                                </v-slider>
                            </div>

                            <!-- 預報產品時間 -->
                            <div v-if="item.tag_config && item.tag_config.initial_time_list"
                                class="forecast-text product-setting-content__item"
                                v-html="get_forecast_text(item)"
                            />
                            
                            <!-- 雷達回波 3D 按鈕 -->
                            <div v-if="item.tag_config && item.tag_config.vertical"
                                class="control-btn product-setting-content__item"
                            >
                                <v-btn 
                                    class="control-btn__content" 
                                    @click="set_is_open_vertical_radar(!is_open_vertical_radar)"
                                >
                                    <a class="control_btn waves-effect"
                                        :class="{ 'control-btn__item--active': is_open_vertical_radar }"
                                    >
                                        自訂<br>
                                        剖面
                                    </a>
                                </v-btn>
                            </div>

                            <!-- 警示產品訊息 -->
                            <div v-if="item.sub_type === 'alert'"
                                class="control-switch product-setting-content__item"   
                            >
                                顯示{{ item.text }}
                                <v-switch
                                    v-model="is_show_alert_table"
                                    dense
                                    class="control-switch__item"
                                />
                            </div>

                            <!-- 颱風互動功能 -->
                            <div v-if="item.sub_type === 'ty_track'"
                                class="control-btn product-setting-content__item"
                                :class="{
                                    'control-btn--en': language === 'en'
                                }"
                            >
                                <v-btn 
                                    class="control-btn__content"
                                    @click="toggle_typhoon_time_display"
                                >
                                    <a class="control-btn__item waves-effect waves-light"
                                        :class="{ 'control-btn__item--active': is_show_typhoon_time }"
                                    >
                                        {{ $t('__geojson.typhoon_route') }}<br>
                                        {{ $t('__geojson.typhoon_time') }}
                                    </a>
                                </v-btn>

                                <v-btn 
                                    class="control-btn__content"
                                    @click="toggle_typhoon_animation"
                                >
                                    <a class="control-btn__item waves-effect waves-light"
                                        :class="{ 'control-btn__item--active': is_show_typhoon_animation }"
                                    >
                                        {{ $t('__geojson.typhoon_route') }}<br>
                                        {{ $t('__geojson.typhoon_animation') }}
                                    </a>
                                </v-btn>
                            </div>

                            <!-- 累積雨量功能 -->
                            <div v-if="accumlated_precp_id_list.includes(item.name)"
                                class="control-switch product-setting-content__item"   
                            >
                                顯示{{ item.text }}表格
                                <v-switch
                                    v-model="is_show_accumulated_precp_table"
                                    dense
                                    class="control-switch__item"
                                />
                            </div>

                            <div v-if="item.sub_type === 'dropsonde'"
                                class="product-setting-content__item"
                            >
                                <hPaControl />
                            </div>

                            <div v-if="set_val[item.name]"
                                class="product-setting-content__item"
                            >
                                <span class="small-text">
                                    {{ $t('__product_setting.opacity') }}： {{ set_val[item.name] * 100 }}%
                                </span>
                                <span class="menu-range">
                                    <input
                                        v-model="set_val[item.name]"
                                        name="name"
                                        @change="change_opacity(item.name, $event.target.value)"
                                        type="range"
                                        min="0"
                                        max="1"
                                        step="0.1"
                                    >
                                </span>
                            </div>

                            <!-- 回波警示表 -->
                            <div v-if="item.tag_config && item.tag_config.toggle_tooltip_btn"
                                class="control-switch product-setting-content__item"   
                            >
                                顯示{{ item.text }}
                                <v-switch
                                    v-model="is_show_monitor_tooltip"
                                    dense
                                    class="control-switch__item"
                                    @change="toggle_monitor_tooltip(item)"
                                />
                            </div>

                            <!-- 機場閃電警示 -->
                            <div v-if="item.sub_type==='lightning_alert'"
                                class="control-switch product-setting-content__item"   
                            >
                                顯示{{ item.text }}
                                <v-switch
                                    v-model="is_show_alert_table"
                                    dense
                                    class="control-switch__item"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else-if="item.is_on_map === false || judge_empty_data(item.tag_config)">
                        <div class="product-setting-content__title d-flex align-center justify-space-between">
                            <div class="d-flex align-center">
                                <v-icon class="svg-icon" 
                                    color="white"
                                >
                                    icon-play-cloud-off
                                </v-icon>
                                <div>
                                    <div v-if="item.is_on_map && judge_empty_data(item.tag_config)"
                                        class="small-text" 
                                    >
                                        {{ item.tag_config.data_empty.text }}
                                    </div>
                                    <div v-else-if="item.tag_config.no_data === 'pink'"
                                        class="small-text" 
                                    >
                                        {{ $t('__product_setting.no_release') }}
                                    </div>
                                    <div v-else-if="item.information.length > 0"
                                        class="small-text" 
                                    >
                                        {{ $t('__product_setting.fix') }}
                                    </div>
                                    <div v-else
                                        class="small-text" 
                                    >
                                        {{ $t('__product_setting.no_data') }}
                                    </div>
                                    <div>
                                        {{ item.text }}
                                    </div>
                                    <div v-if="accumlated_precp_id_list.includes(item.name)"
                                        class="control-switch"   
                                    >
                                        顯示{{ item.text }}表格
                                        <v-switch
                                            v-model="is_show_accumulated_precp_table"
                                            dense
                                            class="control-switch__item"
                                        />
                                    </div>
                                </div>
                            </div>                            
                            <div v-if="item.information && item.information.length > 0">
                                <InformationTooltip
                                    :information="item.information"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="product-setting-content__title d-flex align-center justify-space-between">
                            <div class="d-flex align-center">
                                <v-icon class="svg-icon" 
                                    color="white"
                                >
                                    icon-visibility
                                </v-icon>
                                <span>{{ item.text }}</span>
                            </div>
                            <v-icon class="handle svg-icon"
                                color="#b3b7c4" 
                            >
                                icon-move
                            </v-icon>
                        </div>
                    </template>
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapGetters } from 'vuex'
    import isEqual from 'lodash/isEqual';
    import draggable from 'vuedraggable'

    export default {
        name: 'ProductSettingItems',

        components: {
            draggable,
            RadarControl: () => import('@/components/emap/emap_custom_plugin/radar_control.vue'),
            hPaControl: () => import('@/components/emap/emap_custom_plugin/dot_star/hPa_control.vue'),
            InformationTooltip: () => import('@/components/notification/information_tooltip.vue'),
        },

        props: {
            panes: {
                type: Object,
                require: true,
                default: () => ({})
            },
            
            panes_tag: {
                type: Array,
                require: true,
                default: () => []
            },
            
            order_tool: {
                type: Array,
                default: () => []
            },

            opacity_tool: {
                type: Object,
                default: () => ({})
            },

            all_map_config: {
                type: Object,
                default: () => ({})
            },

            props_zoom_level: {
                type: Number,
                default: 7
            }
        },

        data() {
            return {
                mutable_product_setting_items: [],
                mutable_opacity_tool: {},
                zoom_level: this.props_zoom_level,
            }
        },

        computed: {
            ...mapState([
                'language'
            ]),

            ...mapState('emap', [
                'current_timestamp',
                'is_open_vertical_radar',
                'is_show_typhoon_time',
                'is_show_typhoon_animation',
                'accumlated_precp_id_list',
            ]),

            ...mapGetters('emap', [
                'radar_id',
            ]),

            setting_items() {
                return this.panes_tag.map(pane_tag => {
                    const { text } = pane_tag
                    const [ category, description ] = text.split('-')
                    return {
                        ...pane_tag, 
                        category, 
                        description
                    }
                })
            },

            order_name_list() {
                return this.mutable_product_setting_items.map(({name}) => name)
            },

            set_val() {
                return this.mutable_opacity_tool.set_val
            },

            is_show_alert_table: {
                get() {
                    return this.$store.state.emap.is_show_alert_table
                },

                set(value) {
                    this.set_is_show_alert_table(value)
                }
            },

            is_show_accumulated_precp_table: {
                get() {
                    return this.$store.state.emap.is_show_accumulated_precp_table
                },

                set(value) {
                    this.set_is_show_accumulated_precp_table(value)
                }
            },

            is_show_monitor_tooltip: {
                get() {
                    return this.$store.state.emap.is_show_monitor_tooltip
                },

                set(value) {
                    this.set_is_show_monitor_tooltip(value)
                }
            },
        },

        watch: {
            order_tool: { // 換產品時
                deep: true,
                handler(new_order_tool, old_order_tool) {
                    if (isEqual(new_order_tool, old_order_tool)) return;
                    this.mutable_product_setting_items = this.order_tool.map(item => {
                        const setting_item = this.setting_items.find(({name}) => name === item.name)
                        return {
                            ...item, 
                            ...setting_item,
                            visibility_by_user: true,
                        }
                    })

                    
                    this.mutable_product_setting_items.forEach((setting_item) => {
                        const { name, visibility_by_user, is_on_map } = setting_item
                        const is_product = name.includes('id')
                        is_product && is_on_map && this.change_visibility(name, visibility_by_user)
                    })
                }
            },

            setting_items: { // 切時間軸時，不能重置
                immediate: true,
                deep: true,
                handler() {
                    this.mutable_product_setting_items = this.mutable_product_setting_items.map(item => {
                        const setting_item = this.setting_items.find(({name}) => name === item.name)
                        return {...item, ...setting_item}
                    })
                }
            },

            opacity_tool: {
                immediate: true,
                handler() {
                    this.mutable_opacity_tool = this.opacity_tool
                }
            },

            props_zoom_level: {
                immediate: true,
                handler() {
                    this.zoom_level = this.props_zoom_level
                }
            },

            zoom_level() {
                if (this.zoom_level !== this.props_zoom_level) {
                    this.$emit('change-zoom', this.zoom_level)
                }
            }
        },
        
        methods: {
            ...mapMutations('emap', [
                'set_is_open_vertical_radar',
                'set_is_show_alert_table',
                'set_is_show_typhoon_time',
                'set_is_show_typhoon_animation',
                'set_is_show_accumulated_precp_table',
                'set_is_show_monitor_tooltip',
            ]),

            close_product_setting_dialog() {
                this.$emit('close-product-setting-dialog')
            },

            judge_empty_data(tag_config) {
                return tag_config?.data_empty?.status ?? false
            },

            change_opacity(name, val) {
                this.$emit('change_opacity', name, val)
            },

            change_order(order_list) {
                this.$emit('change_order', order_list)
            },

            toggle_visibility(name, visibility_by_user) {
                const new_visibility_by_user = !visibility_by_user
                this.mutable_product_setting_items = this.mutable_product_setting_items.map(item => {
                    if (item.name !== name) return item

                    return {
                        ...item,
                        visibility_by_user: new_visibility_by_user
                    }
                })

                this.change_visibility(name, new_visibility_by_user)
            },

            change_visibility(name, new_visibility_by_user) {
                const visibility_value = new_visibility_by_user ? 'visible' : 'hidden'
                this.$emit('change_visibility', name, visibility_value)
            },

            toggle_typhoon_time_display() {
                this.set_is_show_typhoon_time(!this.is_show_typhoon_time)
            },

            toggle_typhoon_animation() {
                this.set_is_show_typhoon_animation(!this.is_show_typhoon_animation)
            },

            get_forecast_text({ data, name, tag_config }) {

                const _get_time_string = (d) => {
                    return `
                        ${("00" + (d.getMonth() + 1)).slice(-2)}/${("00" + d.getDate()).slice(-2)} 
                        ${("00" + d.getHours()).slice(-2)}:${("00" + d.getMinutes()).slice(-2)}
                    `;
                }
                
                const is_need_data_exist = data?.list.length > 0 && tag_config?.initial_time_list.length > 0
                if (!is_need_data_exist) {
                    return ''
                }

                const compared_key = `${name}_${this.current_timestamp}`;
                const current_timestamp_index = data.list.findIndex(({key}) => key === compared_key);
                if (current_timestamp_index < 0) {
                    return ''
                }
                
                const forecast_timestamp = [
                    tag_config.initial_time_list[current_timestamp_index],
                    this.current_timestamp,
                ]

                const forcast_time_string = forecast_timestamp.map(timestamp => {
                    const time_date = new Date(+timestamp);
                    return _get_time_string(time_date)
                })

                return `
                    ${this.$t("__product_setting.init_text")}: ${forcast_time_string[0]}<br>
                    ${this.$t("__product_setting.forecast_text")}: ${forcast_time_string[1]}
                `;
            },

            get_gis_slider_labels(all_map_config, sub_type) {
                const max_zoom = all_map_config.map.options.maxZoom
                const min_zoom = all_map_config.map.options.minZoom
                const show_zoom = all_map_config.wmarker[sub_type].zoom_ctrl?.show.params
                
                return [...new Array(max_zoom - min_zoom)].map((item, index) => {
                    return (min_zoom + index) === show_zoom ? this.$t('__product_setting.visible_information') : ''
                })
            },

            toggle_monitor_tooltip(item) {
                //回波警示表
                if(this.panes[item.name].options.pane_tag_config.toggle_tooltip) {
                    this.panes[item.name].options.pane_tag_config.toggle_tooltip()
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../css/mixin';

    .product-setting-items {
        margin: 0 8px 0 0;
        padding: 8px 0 0;
        width: 17.5rem;
        background-color: var(--base-dark-blue);
        border-radius: 8px;
        box-shadow: 4px 0 8px 0 rgba(0, 0, 0, .32);

        &__title {
            width: 100%;
            text-align: center;

            .text {
                color: #fff;
            }

            .close_24px {
                position: absolute;
                top: 8px;
                right: 13px;
            }
        }

        .product-setting-item {
            margin: 8px;
            padding: 0;
            color: #fff;
            background-color: var(--base-gray);
            border-radius: 4px;
            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .32);
        }

        .draggable-item {
            overflow-y: auto;
            height: calc(100vh - 180px);
            min-height: 100px;

            .handle {
                color: #fff;
                cursor: grab;
            }
        }
    }

    .control-switch {
        display: flex;
        justify-content: space-between;
        max-height: 2rem;
        font-size: .75rem;

        &__item {
            display: inline-block;
            margin-top: 0;
            padding-top: 0;
        }
    }

    .control-btn {
        margin-bottom: .5rem;

        @include device-hoverable {
            &:hover {
                color: var(--aqua-active);
            }
        }

        &--en {
            display: grid;
        }

        &__content {
            margin: 5px .5rem 0 0;
            background: var(--base-gray-darken) !important;
        }

        &__item {
            color: var(--grey-pipe);

            &--active {
                color: var(--aqua-active);
            }
        }
    }

    .svg-icon {
        margin-right: 4px;
        width: 1.5rem;
        height: 1.5rem;
    }

    .small-text {
        font-size: 12px !important;
        line-height: 1.2;
    }

    .product-setting-content {
        &__title {
            padding: 6px;
        }

        &__item {
            box-sizing: border-box;
            margin: 0 18px;
            padding: 4px 16px 4px 23px;
            border-left: 1px solid var(--base-gray-darken);

            &:first-child {
                margin: 6px 18px 0;
            }
        }

        &__visibility-btn {
            cursor: pointer;
            border-radius: 100%;
        }
    }

    .gis-slider {
        margin-bottom: .5rem;

        &__title {
            font-size: .75rem;
            letter-spacing: .5px;
            line-height: 1.33;
        }

        &__hint-text {
            color: var(--grey-pipe);
        }
    }

    .forecast-text {
        font-size: .9rem;
    }

    .empty-wrapper {
        background-color: var(--base-gray-darken) !important;

        .product-setting-content {
            &__title {
                color: var(--grey-pipe);
            }
        }
    }
</style>

<style scoped>

    .gis-slider >>> .v-slider__tick {
        top: calc(50% - .1875rem) !important;
        height: .375rem !important;
        background-color: #fff;
    }

    .gis-slider >>> .v-slider__track-fill {
        background-color: #fff !important;
    }

    .gis-slider >>> .v-slider__track-background.v-slider__track-background {
        /* 重複兩次 .v-slider__track-background 是為了加高權重 */
        background-color: #fff !important;
    }

    .gis-slider >>> .v-slider__tick-label {
        top: 1rem;
        font-size: .75rem;
        letter-spacing: .5px;
        line-height: 1.33;
        text-align: center;
    }

    .gis-slider >>> .v-slider__tick-label::before {
        content: '\A';
        position: relative;
        bottom: 1rem;
        left: .1rem;
        height: 0;
        white-space: pre;
        border-left: 7.5px solid transparent;
        border-right: 7.5px solid transparent;
        border-bottom: 13px solid var(--base-orange);
    }

    .gis-slider >>> .v-slider__thumb {
        left: initial;
        transform: translate(-50%, -50%);
        width: 1rem;
        height: 1rem;
        background-color: #fff !important;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, .5);
    }

    .gis-slider >>> .v-slider__thumb::before {
        content: none;
    }
</style>